import { api as managementApi } from "../api";
import { CollectionResponse } from "../../types";
import { Account } from "../account/types";

export enum UnitStatusEnum {
    Initial = "initial",
    Ready = "ready",
    Harvesting = "harvesting",
    HarvestingError = "harvesting_error",
    Harvested = "harvested",
    Booking = "booking",
    Processing = "processing",
    ProcessingError = "processing_error",
    Processed = "processed",
    Invalid = "invalid",
    Skipped = "skipped",
}

export type UnitFormat = "pdf" | "isdoc" | "ubl";

export interface Unit {
    id: number;
    accountId: number;
    documentId: number;
    harvyId: string;
    format: UnitFormat;
    autoBookable: boolean;
    status: string;
    time: string;
    account: Account;
}

export interface SearchParams {
    account?: string;
    status?: UnitStatusEnum;
    priority?: boolean;
    page: number;
    perPage: number;
}

export interface Request {
    unitId: number;
    reason: string;
}

export const unitsApi = managementApi.injectEndpoints({
    endpoints: (build) => ({
        getUnits: build.query<CollectionResponse<Unit>, SearchParams>({
            query: (params) => ({
                url: `api/v1/management/units`,
                params: {
                    page: params.page,
                    per_page: params.perPage,
                    "filter[account]": params.account,
                    "filter[status]": params.status,
                    "filter[priority]": params.priority,
                },
            }),
            providesTags: ["Units"],
        }),
        getUnit: build.query<Unit, number>({
            query: (id) => ({
                url: `api/v1/management/units/${id}`,
            }),
            providesTags: ["Units"],
        }),
        processUnit: build.mutation<Unit, Request>({
            query: (body) => ({
                url: `api/v1/management/process`,
                method: "POST",
                body,
            }),
            invalidatesTags: (result) => [{ type: "Units", id: result.id }],
        }),
        requeueUnit: build.mutation<Unit, Request>({
            query: (body) => ({
                url: `api/v1/management/requeue`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Units"],
        }),
        retryAutoBooking: build.mutation<Unit, number>({
            query: (id) => ({
                url: `api/v1/supervising/units/${id}/auto_booking_retry`,
                method: "POST",
            }),
            invalidatesTags: ["Units"],
        }),
    }),
});

export const {
    useGetUnitQuery,
    useGetUnitsQuery,
    useProcessUnitMutation,
    useRequeueUnitMutation,
    useRetryAutoBookingMutation,
} = unitsApi;
